import { compose } from 'redux';
import APP from '../types/app';
import { osMajorVersion, osMinorVersion, osName } from '../selectors/userAgent';
import resolveSupportedDrmType from '../utils/getDrmType';
import { gte, eq } from '../utils/fns';

const reducers = new Map([[APP.SET_UA, setUserAgent]]);
const userAgent = (state = {}, action) =>
  (reducers.has(action.type) && reducers.get(action.type)(state, action.payload)) || state;

export default userAgent;

const isMacOS = eq('Mac OS');
const gte10 = gte(10);
const gte14 = gte(14);
const cutBitratePredicates = [
  compose(isMacOS, osName),
  compose(gte10, osMajorVersion),
  compose(gte14, osMinorVersion),
];
const cut = (streamInfo) => ({ ...streamInfo, bitrates: [] });
const noop = (streamInfo) => streamInfo;
const cutDrmOnly = (stream) => [noop, cut][+(stream.drm_type === 'fairplay')](stream);

function setUserAgent(state, userAgent) {
  const useCutBitrate = cutBitratePredicates
    .map((predicate) => predicate({ userAgent }))
    .every(Boolean);
  const bitratesCut = [noop, cutDrmOnly][+useCutBitrate];
  const supportedDrmType = resolveSupportedDrmType(userAgent);

  return {
    ...state,
    ...userAgent,
    bitratesCut,
    supportedDrmType,
  };
}
